import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const TONE = { ok: "text-emerald-700", warn: "text-amber-700", block: "text-rose-700", info: "text-slate-500" };

export function DryRun({ wcId, offerVid, refreshKey }) {
  const [d, setD] = useState(null);
  useEffect(() => {
    const q = offerVid ? `?wc_variation_id=${offerVid}` : "";
    api.get(`/online-catalogue/items/${wcId}/dry-run${q}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [wcId, offerVid, refreshKey]);
  if (!d) return <p className="text-xs text-slate-400">Loading dry run…</p>;
  return (
    <div className="space-y-3" data-testid="oc-dry-run">
      <div className="flex flex-wrap gap-2 text-xs">
        <span className="px-2 py-0.5 rounded bg-slate-900 text-white" data-testid="oc-dry-run-writes">{d.google_writes}</span>
        <span className={`px-2 py-0.5 rounded font-semibold ${d.live_publishing_eligible ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`} data-testid="oc-dry-run-eligible">
          {d.live_publishing_eligible ? "LIVE PUBLISHING ELIGIBLE" : `NOT LIVE ELIGIBLE · blocked by ${d.blocked_by.join(", ")}`}
        </span>
      </div>
      <table className="w-full text-xs">
        <tbody>{d.checks.map((c) => (
          <tr key={c.attribute} className="border-t" data-testid={`oc-check-${c.attribute}`}>
            <td className="py-1 pr-2 font-medium w-40">{c.attribute}</td>
            <td className={`pr-2 font-semibold w-14 uppercase ${TONE[c.status]}`}>{c.status}</td>
            <td className="text-slate-600 break-all">{c.note}</td>
          </tr>))}
        </tbody>
      </table>
      <pre className="text-[11px] bg-slate-50 border rounded-lg p-3 overflow-auto max-h-80" data-testid="oc-dry-run-payload">{JSON.stringify({ offerId: d.offerId, contentLanguage: d.contentLanguage, feedLabel: d.feedLabel, attributes: d.attributes }, null, 2)}</pre>
    </div>
  );
}
